<template>
  <div class="">
    <div class="row">
      <Header
        titulo="Gerador de links para WhatsApp"
        subtitulo="Crie links diretos para conversas no WhatsApp"
      ></Header>
      <div class="container">
        <div class="col-12 py-3">
          <div class="form-group">
            <label for="">Seu número</label>
            <the-mask
              type="text"
              class="form-control"
              placeholder="+55 99 90000 0000"
              v-model="numero"
              inputmode="tel"
              :mask="['+## ## #####-####']"
            />
            <div class="form-text">Número que receberá as mensagens</div>
          </div>
          <div class="form-group">
            <label for="">MENSAGEM (Opcional)</label>
            <textarea
              type="text"
              v-model="mensagem"
              class="form-control"
              placeholder="Opcional"
            />
            <div class="form-text">Mensagem que você quer receber.</div>
          </div>
          <div v-show="showBtn" class="row">
            <div
              class="col-12 d-flex justify-content-between justify-content-lg-around"
            >
              <button @click="Geralink()" class="btn btn-success col-5">
                GERAR LINK
              </button>
              <button
                v-show="numero"
                @click="(numero = ''), (mensagem = ''), (url = '')"
                class="btn btn-danger col-5"
              >
                LIMPAR
              </button>
            </div>
          </div>
        </div>

        <div class="row" v-show="this.url">
          <div class="col-12">
            <div class="form-group">
              <label for="exampleFormControlTextarea1"
                >SEU LINK FOI GERADO</label
              >
              <textarea
                class="form-control"
                id="url"
                rows="3"
                v-model="this.url"
                readonly
              ></textarea>
            </div>
          </div>
          <div
            class="col-12 d-flex justify-content-between justify-content-lg-around"
          >
            <button
              id="copiar"
              data-clipboard-target="#url"
              class="btn btn-primary col-5"
            >
              COPIAR
            </button>
            <a target="_blank" :href="this.url" class="btn btn-warning col-5"
              >TESTAR</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import ClipboardJS from "clipboard";
new ClipboardJS("#copiar");
export default {
  components: {
    Header,
  },
  data() {
    return {
      numero: "",
      mensagem: "",
      url: "",
      showBtn: false,
    };
  },
  methods: {
    Geralink() {
      let n = this.numero.replace(/[^0-9]/g, "");
      let m = encodeURI(this.mensagem);
      this.url = `https://wa.me/send?phone=${n}&text=${m}`;
    },
  },
  watch: {
    numero() {
      this.numero.replace(/[^0-9]/g, "").length >= 13
        ? (this.showBtn = true)
        : (this.showBtn = false);
    },
  },
};
</script>

<style>
textarea {
  resize: none;
}
</style>
